import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgParasailer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 362,
	height: 373,
	fill: "none",
	viewBox: "0 0 392 373",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			className: "boat",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFBB96",
					d: "m49.6 346.44-.62-.35a.37.37 0 0 1-.13-.49c.06-.12.12-.25.16-.37a2.01 2.01 0 0 0 0-.8c0-.12.01-.65.17-.9.13-.2.49-.35.62-.4a.24.24 0 0 1 .11-.02c.14.02.46.08.63.34.14.23.14.7 0 .93-.08.12-.37.3-.29.42l.32.48c.08.12.08.28-.01.4l-.52.68c-.1.13-.3.17-.44.08Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#031839",
					d: "M48.33 343.36c-.34.34.68 1.02.68 1.02s.04-.64.34-.93c.23-.23.76-.26.76-.26s.31-.52.26-.76c-.07-.28-.31-.4-.6-.43-.35-.03-.43.37-.76.51-.2.09-.42-.02-.51.17-.1.19.28.33.17.51-.08.13-.24.07-.34.17Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFC45F",
					d: "M49.86 346.17c-.25.06-.66-.16-.93-.33a.67.67 0 0 0-.57-.1c-.4.14-1.08.44-1.4.94-1 1.6-1.1 4.9-1.1 6.22 0 .33.25.6.58.65l6.42.83c.42.06.8-.28.76-.71-.17-1.97-.66-6.88-1.47-8.1-.22-.33-.74-.42-1.1-.43-.27-.01-.48.16-.6.39-.14.26-.35.57-.6.64Z"
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter0_d_15894_38407)",
					children: /* @__PURE__ */ _jsx("path", {
						fill: "#FFC45F",
						d: "M42.64 349.48s1.5-.5 2.54-.68c1.15-.2 2.8-1.02 2.8-1.02l-.59 1.7s-1.56 1.1-2.46 1.1c-.9 0-2.3-.25-2.3-.25v-.85Z"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#18A0FB",
					fillOpacity: .2,
					stroke: "#FA4969",
					strokeWidth: .17,
					d: "m34.49 343.54-7.83 3.3s7.75 1.18 12.66 2.21a288.9 288.9 0 0 1 12.28 3c.1.03.21-.05.21-.16v-.67c0-.24-.1-.48-.29-.64a31.85 31.85 0 0 0-1.92-1.53c-2.4-1.7-4.07-2.18-6.8-3.31a86.74 86.74 0 0 0-6.6-2.29 2.5 2.5 0 0 0-1.71.1Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FA4969",
					d: "M77.69 363.8c-.2 1.3-.9 3.01-1.19 3.65a.33.33 0 0 1-.38.19l-3.16-.77a2.55 2.55 0 0 1-1.82-3.25l1.58-5a1.6 1.6 0 0 1 2.5-.8l1.59 1.2c.56.44.92 1.08.96 1.79.04.87.06 2.09-.08 2.99Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#FA4969",
					strokeWidth: .17,
					d: "m42.64 345.74-2.38 3.65"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FA4969",
					d: "m76.98 367.9-50.62-2.6a1.61 1.61 0 0 1-.71-.2c-1.64-.9-9-5.03-13.43-8.74-4.58-3.83-10.4-10.9-11.65-12.44-.1-.12-.02-.29.13-.27 3.2.28 25.88 2.34 40.15 5.4 11.4 2.45 26.95 8.18 29.67 9.2.27.1.5.27.7.5l6.46 7.76a.85.85 0 0 1-.7 1.39Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#F0F4FA",
					d: "m58.04 366.9-31.67-1.6c-.26-.01-.5-.08-.72-.2-1.65-.9-9-5.04-13.43-8.74a70.26 70.26 0 0 1-9.15-9.58c-.1-.13 0-.3.15-.27 3.22.7 23.67 5.12 37.8 8.15 12.07 2.59 14.92 6.58 15.11 6.87l.03.03 2.64 4.02a.85.85 0 0 1-.76 1.32Z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M77.32 368h46v1h-46zm16 4h23v1h-23zm30 0h23v1h-23z"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "sail-and-tether",
			children: [/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: .24,
				d: "m79 365 218.5-258.5"
			}), /* @__PURE__ */ _jsxs("g", {
				className: "sail",
				children: [
					/* @__PURE__ */ _jsx("path", {
						stroke: "#000",
						strokeWidth: .24,
						d: "m265.5 34.99 29.08 61.34m-14.6-62.05 16.25 63.11m0-61.23 3.42 62.53m10.95-58.05-10.25 58.99m24.73-53.1-22.49 53.69m36.61-44.86-37.44 46.62m59.58-62.64-58.75 62.52"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#74C6FD",
						d: "M261.03 26.16c.35 4.89 4.46 8.6 4.46 8.6s5.26-4 8.13-4.13c3.17-.14 5.88 4.12 5.88 4.12s4.96-4.6 12.37-3.3c4.82.85 4.82 4.71 4.82 4.71s1.78-2.47 7.67-.58c3.25 1.04 6.58 5.53 6.58 5.53s4.91-1.01 7.77 0c3.08 1.09 6.36 5.42 6.36 5.42s2.95-1.42 5.54 0c6.2 3.38 8 9.3 8 9.3s22.04-10.72 23.2-17.78c2.13-12.95-13.73-29.02-32.14-35.2-12.95-4.36-35.2-3.19-46.52 0-11.44 3.2-22.76 14.48-22.12 23.3Z"
					}),
					/* @__PURE__ */ _jsx("mask", {
						id: "mask0_15894_38407",
						width: 102,
						height: 56,
						x: 261,
						y: 0,
						maskUnits: "userSpaceOnUse",
						style: { maskType: "alpha" },
						children: /* @__PURE__ */ _jsx("path", {
							fill: "#74C6FD",
							d: "M261.03 26.16c.35 4.89 4.46 8.6 4.46 8.6s5.26-4 8.13-4.13c3.17-.14 5.88 4.12 5.88 4.12s4.96-4.6 12.37-3.3c4.82.85 4.82 4.71 4.82 4.71s1.78-2.47 7.67-.58c3.25 1.04 6.58 5.53 6.58 5.53s4.91-1.01 7.77 0c3.08 1.09 6.36 5.42 6.36 5.42s2.95-1.42 5.54 0c6.2 3.38 8 9.3 8 9.3s22.04-10.72 23.2-17.78c2.13-12.95-13.73-29.02-32.14-35.2-12.95-4.36-35.2-3.19-46.52 0-11.44 3.2-22.76 14.48-22.12 23.3Z"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						fill: "#FA4969",
						mask: "url(#mask0_15894_38407)",
						children: /* @__PURE__ */ _jsx("path", { d: "M317.38 21.56c-4.65 7.15-7.37 19.55-7.37 19.55l13.9 9.65c4.54-9.05 2.58-11.77 10.82-21.54 8.25-9.78 20.73-12.6 20.73-12.6s-4.99-4.34-8.48-6.71c-3.94-2.68-10.6-6-10.6-6s-8.35 1.29-19 17.65Zm-30.21-9.42c-7.11 7.25-7.78 23.67-7.78 23.67l15.2 2.94c4.55-9.05 2.47-9.3 10.35-21.3 7.9-12.02 22.5-16.73 22.5-16.73s-2.05-.21-5.54-2.59c-3.94-2.67-4.47-.59-4.47-.59s-20.57 4.71-30.26 14.6Z" })
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#FFBB96",
						d: "m299.64 95.3.86-.5a.5.5 0 0 0 .18-.68 3.01 3.01 0 0 1-.22-.5 2.8 2.8 0 0 1 0-1.1c0-.19-.02-.91-.24-1.26-.18-.3-.68-.5-.87-.57a.34.34 0 0 0-.15-.02c-.18.03-.63.11-.86.47-.2.32-.2.97 0 1.3.1.16.5.42.4.58l-.45.66c-.11.17-.1.4.02.55l.72.94c.14.19.4.24.6.12Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#031839",
						d: "M304.82 91.6c-.67 0-4.36.83-4.36.83s-.06-.88-.47-1.3c-.32-.3-2 .48-2 .48s-.08-1.19 0-1.53c.08-.39 2.07-1.03 2.47-1.06.5-.05.37.5.82.7.27.12 1.53-1.06 2.36-.35.82.7 2.3.68 2.59.7 1.06.12-.6 1.54-1.41 1.54Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#E4940B",
						d: "m294.57 96.9.66-2.63a.28.28 0 0 0-.47-.26L293 95.77a.93.93 0 0 0-.25.46l-.42 1.86a.94.94 0 0 0 .84 1.14l.89.08c.49.04.86.44.86.94v1.47c0 .3.15.59.4.76.59.39 1.73 1.1 2.65 1.37.97.28 2.35.26 3.24.2a.9.9 0 0 0 .83-.97l-.12-1.46a.94.94 0 0 1 1.55-.8l.3.25a.81.81 0 0 0 1.29-.87l-.99-3.03a.94.94 0 0 0-.3-.44l-2.68-2.23a.94.94 0 0 0-1.09-.08l-.56.34a.62.62 0 0 1-.9-.3.62.62 0 0 0-.99-.25l-2.98 2.7Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#FFF4E0",
						d: "m297.89 103.14-2.21-1.23a.9.9 0 0 0-1 .06c-1.22.96-4.44 3.67-5.06 6.24-.62 2.59 1.14 5.91 1.72 6.9.1.18.16.4.13.61l-.31 2.74a.94.94 0 0 0 1.78.52l1.67-3.44c.05-.1.08-.2.1-.32l.39-4.13c.03-.39.3-.71.68-.83.9-.29 2.6-.88 3.62-1.58 1.43-.98 2.21-3.06 2.57-4.33a.87.87 0 0 0-.86-1.09h-2.76a.95.95 0 0 1-.46-.12Z"
					})
				]
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_15894_38407",
			width: 6.03,
			height: 3.48,
			x: 42.3,
			y: 347.78,
			colorInterpolationFilters: "sRGB",
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					result: "hardAlpha",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: .34 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .17 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }),
				/* @__PURE__ */ _jsx("feBlend", {
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_15894_38407"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					in: "SourceGraphic",
					in2: "effect1_dropShadow_15894_38407",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgParasailer;
